import {Module} from '@gongxigames/framework/slot/fragments/module/Module';
import {GlobalEventsMapForBackwardCompatibility} from '@gongxigames/framework/slot/events';
import {LogicEvents} from '@gongxigames/framework/slot/services/logic/LogicEvents';
import {PickBonusView} from '@gongxigames/framework/slot/modules/pick/PickBonusView';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow';
import {GenericPopupEvents} from '@gongxigames/framework/slot/modules/genericPopup/';
import {PickBonusEvents} from '@gongxigames/framework/slot/modules/pick/PickBonusEvents';

export class PickBonusModule extends Module<PickBonusView, GlobalEventsMapForBackwardCompatibility> {
    public static readonly NAME: symbol = Symbol('PickBonusModule');
    protected static readonly ITEMS_AMOUNT: number = 12;

    protected _items: number[] = [];

    protected setupViews(): void {
        this.setView(PickBonusView.NAME);
    }

    protected setupStates(): void {
    }

    protected setupEvents(): void {
        super.setupEvents();

        this.on(FlowModuleEvents.START_PICK_BONUS, this.onStartPickBonus);
        this.on(FlowModuleEvents.RESTORE_PICK_BONUS, this.onRestorePickBonus);
        this.on(LogicEvents.PICK_RESPONSE, this.onPickResponse);
        this.on(GenericPopupEvents.FADE_OUT_STARTED, this.onFadeOutStarted);

        this.onView(PickBonusView.UPDATE_PICKED, this.onUpdatePicked);
    }

    protected onStartPickBonus(): void {
        this.eventManager.emit('General.UI.DISABLE', PickBonusModule.NAME);
        this.initItems();
        this.view.start(this.logic.getPickedValues()!);
        this.eventManager.emit(PickBonusEvents.STARTED);
    }

    protected onRestorePickBonus(): void {
        this.onStartPickBonus();
    }

    protected onPickResponse(): void {
        const values = this.logic.getPickedValues()!;
        const last = values[values.length - 1];
        const [index, value] = last;

        this.pick(index, value);
    }

    protected onFadeOutStarted(): void {
        this.onFinishPickBonus();
    }

    protected onUpdatePicked(listenerId: symbol, index: number, value: number): void {
        if (this._items && this._items[index]) {
            this._items[index] = value;
        }
    }

    protected onFinishPickBonus(): void {
        this.view.stop();
        this.eventManager.emit(PickBonusEvents.FINISHED);
        this.eventManager.emit('General.UI.ENABLE', PickBonusModule.NAME);
    }

    protected pick(index: number, value: number): void {
        this.view.pick(index, value);
    }

    public initItems(): void {
        this._items = new Array(this.itemsAmount).fill(-1);
    }

    protected get itemsAmount(): number {
        return PickBonusModule.ITEMS_AMOUNT;
    }
}
